import tIcon from './icon.vue';

export default {
  install(instance: any) {
    instance.component('tIcon', tIcon);
  },
};
